import React from 'react';
import { TableHeaderColumn } from "react-bootstrap-table";
import { months } from '../../../../Utils/months';
import GridEmpty from '../../../../Utils/Grid/GridEmpty';
import { columnaClaseFija, columnaFijaTotales } from '../../../../../../utility/staticColumns';
const List = props => {
    const { data_summary, loader, onSortChange } = props;
    const dataExportable = data_summary && data_summary.response && data_summary.response.sales_divers && Array.isArray(data_summary.response.sales_divers.results) ? data_summary.response.sales_divers.results : [];
    const formatearNumero = (dato) => {
        if (dato === null || dato === undefined || isNaN(dato)) {
            return '';
        }

        const formatoMoneda = new Intl.NumberFormat('es-GT', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });
        const numero = Number(dato);
        return "$ " + formatoMoneda.format(numero);
    }
    const columnaClaseTotal = (cell, row) => {
        if (row.name === 'TOTALES') {
            return 'celda-totales';
        }
        return '';
    };

    const meses = months
    const columnas = meses.map((mes, index) => (
        <TableHeaderColumn
            key={index}
            dataField={mes}
            dataSort
            dataFormat={formatearNumero}
            columnClassName={columnaClaseTotal}
            width='130'
            dataAlign='right'
            tdStyle={{ 
                paddingRight: '22px', 
                textAlign: 'right',
                whiteSpace: 'nowrap'
            }}
            thStyle={{ 
                textAlign: 'right',
                paddingRight: '22px'
            }}
        >
            {index + 1}
        </TableHeaderColumn>
    ));


    return (
        <GridEmpty
            hover
            striped
            data={dataExportable}
            loading={loader}
            onSortChange={onSortChange}
            pagination={false}
            className="pb-3"
        >

            <TableHeaderColumn
                dataField="name"
                isKey={true}
                dataSort
                className="table-fixed-cell-left-0"
                columnClassName={columnaClaseFija}
                width='170'
                dataAlign='left'
                tdStyle={{ 
                    paddingLeft: '22px', 
                    textAlign: 'left',
                    whiteSpace: 'normal' 
                }}
                thStyle={{ 
                    textAlign: 'left',
                    paddingLeft: '22px'
                }}
            >
            </TableHeaderColumn>
            <TableHeaderColumn
                dataField="total"
                dataSort
                dataFormat={formatearNumero}
                width='160'
                className="table-fixed-cell-left-1"
                columnClassName={columnaFijaTotales}
                dataAlign='right'
                tdStyle={{ 
                    paddingRight: '22px', 
                    textAlign: 'right',
                    whiteSpace: 'nowrap'
                }}
                thStyle={{ 
                    textAlign: 'right',
                    paddingRight: '22px'
                }}
            >
                Total
            </TableHeaderColumn>
            {columnas}

        </GridEmpty>
    );
};
export default List;